import { render, staticRenderFns } from "./floor-style-3.vue?vue&type=template&id=a8b11170"
import script from "./floor-style-3.vue?vue&type=script&lang=js"
export * from "./floor-style-3.vue?vue&type=script&lang=js"
import style0 from "./floor-style-3.vue?vue&type=style&index=0&id=a8b11170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports